import '../styles/ant-reset.less';
import '../styles/globals.css';
import '../styles/external-html.less';
import { useLayoutEffect } from 'react';

import dataplus from '@lcsc/data-plus';
import { pathDataPolyfill } from '@lcsc-ui/lib/path-data-polyfill';
import { message } from 'antd';

import FlowControlModal from '@/components/FlowControlModal';
import { Toaster } from '@/components/ui/sonner';
import { env } from '@/utils/baseUrl';

const MyNextApp = ({ Component, pageProps }) => {
  useLayoutEffect(() => {
    try {
      dataPlusInit();
      pathDataPolyfill();
    } catch (err) {
      console.log(err);
    }
    message.config({
      top: 150,
      duration: 3,
      maxCount: 5,
    });
  }, []);

  // 监控sdk开关
  function dataPlusInit() {
    // 初始化埋点
    if (typeof window !== 'undefined') {
      let dataplus_url = 'https://collector.szlcsc.com';
      if (['fat', 'dev', 'uat'].includes(env)) {
        dataplus_url = `https://${env}collector.szlcsc.com`;
      } else if (['local'].includes(env)) {
        dataplus_url = `https://devcollector.szlcsc.com`;
      }
      dataplus?.init({
        c_url: `${dataplus_url}/collect.js`,
        pf: 'pc',
      });
      console.log('埋点初始化成功');
    }
  }

  return (
    <div id="lc-item">
      <Component {...pageProps} />
      <FlowControlModal />
      <Toaster
        position="top-center"
        richColors
        style={{
          top: '150px',
        }}
      />
    </div>
  );
};

export default MyNextApp;
